import { IUnitPaymentMethodsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisUnitPaymentMethodsRepository from './implementations/VectisUnitPaymentMethodsRepository';

let instance: IUnitPaymentMethodsRepository | null = null;

export default function makeUnitPaymentMethodsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisUnitPaymentMethodsRepository(httpProvider);
  }

  return instance;
}
